var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", [
    _c(
      "tr",
      _vm._l([1, 2, 3, 4, 5], function(rating) {
        return _c("td", { key: rating, staticClass: "adjust" }, [
          _vm.isFull(rating)
            ? _c("img", {
                attrs: {
                  src: require("../../assets/images/svg/icone_stella-piena.svg"),
                  height: _vm.size
                }
              })
            : _c("img", {
                attrs: {
                  src: require("../../assets/images/svg/icone_stella-vuota.svg"),
                  height: _vm.size
                }
              })
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05db6aea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05db6aea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/common/RatingStars.vue
// module id = null
// module chunks = 